class MergeSuperscriptSpans {
  constructor(config = {}) {
    const {
      scopeSelector,
      superscriptClass,
      mergedClass,
      forceSingleLine
    } = config;

    this.scopeSelector = scopeSelector || 'td p';
    this.superscriptClass = superscriptClass || 'superscript';
    this.mergedClass = mergedClass || 'merged-text';
    this.forceSingleLine = forceSingleLine ?? false;

    this.targets = document.querySelectorAll(this.scopeSelector);
    this.targetsArray = Array.prototype.slice.call(this.targets);

    if (this.targets && this.targetsArray.length) {
      this.run(this.targetsArray);
    }
  }

  run(targetsArray) {
    targetsArray.forEach((p) => {
      this.mergeParagraph(p);
    });
  }

  mergeParagraph(p) {
    if (!p) return;

    const parts = [];
    let hasSuperscript = false;

    Array.prototype.slice.call(p.childNodes).forEach((node) => {
      // Textnode
      if (node.nodeType === Node.TEXT_NODE) {
        const txt = node.textContent.replace(/\s+/g, ' ');
        if (txt.trim()) {
          parts.push(document.createTextNode(txt));
        }
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        // superscript span -> <sup>
        if (node.classList && node.classList.contains(this.superscriptClass)) {
          const sup = document.createElement('sup');
          sup.textContent = node.textContent;
          parts.push(sup);
          hasSuperscript = true;
          return;
        }

        parts.push(document.createTextNode(node.textContent));
      }
    });

    // Only apply merged-text if there's a superscript
    if (!hasSuperscript) {
      return;
    }

    const merged = document.createElement('span');
    merged.className = this.mergedClass;

    parts.forEach((x) => merged.appendChild(x));

    p.innerHTML = '';
    p.appendChild(merged);
  }
}

export default MergeSuperscriptSpans;
